import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { State } from 'redux/initialState';
import { Council } from 'types';
import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';

import 'modules/administratives/styles/Administratives.scss';

import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { useGetSocietyDocuments } from 'modules/society/hooks/useGetSocietyDocuments';
import { hasInternalView } from 'utils/showDetails';
import { useCouncilMember } from './hooks/useCouncilMember';
import { useGetCouncilsList } from '../CouncilsList/hooks/useGetCouncilsList';

import CouncilMembersHeader from './components/CouncilMembersHeader';
import CouncilMembersBasicInfoCard from './components/CouncilMembersBasicInfoCard';
import CouncilMembersDocumentsCard from './components/CouncilMembersDocumentsCard';
import CouncilMembersParticipantsCard from './components/CouncilMembersParticipantsCard';

const CouncilDetailsNew = () => {
  const { societyId } = useParams();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);

  const {
    data: { council, documents },
    isLoading,
  } = useCouncilMember();

  // View mode state: true = Admin view, false = Director view (read-only)
  const [isAdminView, setIsAdminView] = useState(true);

  // Initialize view mode based on user's admin status
  useEffect(() => {
    if (isAdmin !== undefined) {
      setIsAdminView(isAdmin);
    }
  }, [isAdmin]);

  useGetMenu(menuTypes.NULL);
  useGetActualSociety(societyId);
  useGetCouncilsList(societyId);
  useGetSocietyDocuments(societyId);

  return (
    <Page className="bg-lighter pb-5">
      <CouncilMembersHeader
        council={council as Council}
        society={actualSociety}
        isAdminView={isAdminView}
        onViewModeChange={setIsAdminView}
      />

      <div className="row">
        <div className="col-lg-5">
          <CouncilMembersBasicInfoCard
            council={council as Council}
            society={actualSociety}
            isAdminView={isAdminView}
          />
          <CouncilMembersParticipantsCard
            council={council as Council}
            society={actualSociety}
            isAdminView={isAdminView}
          />
        </div>

        <div className="col-lg-7">
          <CouncilMembersDocumentsCard
            council={council as Council}
            documents={documents}
            society={actualSociety}
            isAdminView={isAdminView}
          />
        </div>
      </div>

      {hasInternalView() && (
        <pre className="bg-light rounded-xl p-3 my-4">
          {JSON.stringify(
            {
              ...council,
              participants: council?.participants.length,
            },
            null,
            2
          )}
        </pre>
      )}

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default CouncilDetailsNew;
